import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCQAData } from "../../redux/slicer/gallerySlice";
import parse, { domToReact } from "html-react-parser";
import Preloader from "../../assets/sab.jpeg";
import AcedamicsImg from "../../assets/Banners/Academics.jpg";
import { FaArrowLeft } from "react-icons/fa";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";

function CQAItemDetails() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const cqaId = searchParams.get("id");

  const dispatch = useDispatch();
  const { data: CQAData, loading: CQALoading, error: CQAError } = useSelector(
    (state) => state.gallery.CQA
  );

  const [cqaItem, setCqaItem] = useState(null);

  useEffect(() => {
    dispatch(fetchCQAData()); // Fetch CQA Data
  }, [dispatch]);

  useEffect(() => {
      window.scrollTo(0, 0); // Scroll to top
  }, []); // Empty dependency array ensures this runs only once on mount

  useEffect(() => {
    if (CQAData) {
      const selectedCqaItem = CQAData.find((item) => item.id === parseInt(cqaId));
      setCqaItem(selectedCqaItem);
    }
  }, [CQAData, cqaId]);

  // Function to extract filename from URL
  const getFilenameFromUrl = (url) => {
    try {
      const urlObject = new URL(url);
      const pathname = urlObject.pathname;
      const filename = pathname.substring(pathname.lastIndexOf('/') + 1);
      return decodeURIComponent(filename); // Decode URL-encoded characters
    } catch (error) {
      console.error("Error parsing URL:", error);
      return "Unknown File";
    }
  };

  if (CQALoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img src={Preloader} alt="Loading..." className="w-24 h-24 sm:w-32 sm:h-32" />
      </div>
    );
  }

  if (CQAError) {
    return <div className="text-red-600">Error: {CQAError}</div>;
  }

  if (!cqaItem) {
    return <div>CQA Item not found.</div>;
  }

  return (
    <div className="bg-gray-100 min-h-screen">
      {/* Banner Section */}
      <div className="relative max-w-full mx-auto">
        <div className="contain overflow-hidden w-full  h-[400px]">
          <img
            src={AcedamicsImg} // Or a CQA-related image
            alt="CQA Item Details Banner"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-4xl md:text-5xl  font-bold  font-titillium">{parse(cqaItem.title)}</h2>
            <p className="text-lg mt-10 bg-img-description  font-titillium">
            
            </p>
          </div>
        </div>
      </div>

      {/* Back Button */}
      <div className="container mx-auto mt-8 px-4 sm:px-6 lg:px-8">
        <Link
          to="/acadamics" //  back to the Academics page
          className="inline-flex items-center text-primary-color hover:text-secondary-color font-semibold"
        >
          <FaArrowLeft className="mr-2" />
          Back to Academics
        </Link>
      </div>

      {/* CQA Item Details Section */}
      <div className="container mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow overflow-hidden rounded-md">
          <div className="p-6 md:p-10 relative">
            <div className="border-dotted border-2 border-primary-color rounded-xl p-6 text-left shadow-md">
              {/* Title */}
              <h2 className="text-gray-800 text-lg">
                <span className="font-semibold text-primary-color">Title: </span>
                {parse(cqaItem.title)}
              </h2>

              {/* Description */}
              <p className="mt-2 text-gray-700 text-lg">
                <span className="font-semibold text-primary-color">Description: </span>
                {parse(cqaItem.description)}
              </p>

              {/* Files - Download Links */}
              {cqaItem.files && cqaItem.files.length > 0 && (
                <div className="mt-4">
                  <h3 className="text-xl font-semibold mb-2 text-gray-800">Download Files</h3>
                  <ul className="list-disc pl-5 text-gray-700">
                    {cqaItem.files.map((file, index) => {
                      const filename = getFilenameFromUrl(file);
                      return (
                        <li key={index}>
                          <a
                            href={file}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary-color font-semibold inline-flex items-center hover:text-purple-700 transition-all"
                          >
                            {filename}
                            <span className="ml-2">
                              <BsFillFileEarmarkPdfFill className="text-xl" />
                            </span>
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CQAItemDetails;